import { render, staticRenderFns } from "./manufacturer.vue?vue&type=template&id=de44fbc8"
import script from "./manufacturer.vue?vue&type=script&lang=ts"
export * from "./manufacturer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports